import { ComponentProps, FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Button } from "../Button";

import { Modal } from "./Modal";
import { ModalBody } from "./ModalBody";
import { ModalFooter } from "./ModalFooter";
import { ModalHeader } from "./ModalHeader";

import { RootState } from "@/reducers/types";
import { MachineIcon } from "@/sx-layout/common/MachineIcon";
import { Company } from "@/sx-layout/models";

export type HelpModalProps = ComponentProps<typeof Modal>;

export const HelpModal: FC<HelpModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const companies = useSelector((state: RootState) => state.layoutApp.layoutMasters.companies);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>{t("help")}</ModalHeader>
      <ModalBody size="normal" style={{ padding: "20px 40px" }} className="modal-body w-1000 items-start">
        <div className="flex flex-col items-center justify-center">
          <div className="w-[500px] py-0">
            <div className="bg-white p-5">
              <table>
                <tbody>
                  {companies.map((machine: Company) => (
                    <tr key={machine.company_id}>
                      <td className="py-[5px] px-[10px] flex items-center">
                        <div className="w-[45px] h-[45px] mr-[15px]">
                          <MachineIcon
                            active={true}
                            shapeColor={`#${machine.icon_color}`}
                            machineIconId={2}
                            selected={false}
                          />
                        </div>
                        <span>{machine.company_name}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <p className="mt-[20px]">{t("help_machine_icon_description")}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button buttonType="cancel" onClick={onClose}>
          {t("close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
